import { deg2rad, EquatorialCoord } from "@hscmap/angle";
import { ModuleBase } from "@/modules/base";
import { CatalogOverplot } from "@/modules/CatalogOverplotModule/CatalogOverplot";
import { fileDragAndDrop } from "@/modules/CatalogOverplotModule/file_drag_and_drop";
import { Component, Mixins, Vue, Prop } from 'vue-property-decorator';
import CatalogListWindow from './CatalogListWindow/index.vue';
import OverlayLayer from './OverlayLayer.vue';
import AnalysisMenu from './AnalysisMenu.vue'
import CatalogTableWindow from './CatalogTableWindow/index.vue'
import CatalogChartWindow from './CatalogChartWindow/index.vue'
import ObjectPicker from "./ObjectPicker";
import ObjectInfo from './ObjectInfo.vue'
import { CreateElement, VNode } from "vue";
import { store } from '@/store';
import ContextMenu from './ContextMenu/index.vue'

export interface IRowRef {
  co: CatalogOverplot,
  i: number,
}

@Component
export class CatalogOverplotModule extends Mixins(ModuleBase) {
  showList = false

  frameStore() {
    @Component
    class FrameStore extends Vue {
      cos = [] as CatalogOverplot[]
    }
    return new FrameStore()
  }

  get outlet() {
    return {
      window: [CatalogListWindow, TableWindows, ChartWindows],
      overlayLayer: [OverlayLayer, ObjectPicker],
      analysisMenu: AnalysisMenu,
      frameTool: ObjectInfo,
      contextMenu: ContextMenu,
    }
  }

  async loadFile(file: File) {
    try {
      const co = await CatalogOverplot.fromCsvFile(file)
      store.currentFrame.modules.catalogOverPlot.cos.push(co)
      this.goto(co)
      this.showList = true
    } catch (e) {
      alert(`Failed to load ${file.name}: ${e}`)
    }
  }

  goto(co: CatalogOverplot) {
    if (co.filteredCoord3.length > 0) {
      const coord = EquatorialCoord.fromXyz(co.filteredCoord3[0])
      store.currentGlobe().viewFactory.jumpTo({ fovy: deg2rad(60 / 3600) }, { coord })
    }
  }

  private fileDragAndDropUnset!: () => void
  created() {
    this.fileDragAndDropUnset = fileDragAndDrop.set(document.body, (file) => {
      if (file.name.match(/\.csv(?:\.gz)?$/i)) {
        this.loadFile(file)
      }
    })
  }

  beforeDestroy() {
    this.fileDragAndDropUnset()
  }
}

@Component
class TableWindows extends Vue {
  render(h: CreateElement) {
    return h('div', ([] as VNode[]).concat(...store.frames.map((f) =>
      f.modules.catalogOverPlot.cos.map((co) => {
        return h(CatalogTableWindow, {
          props: {
            module: store.modules.catalogOverPlot,
            co,
            frame: f,
          },
          key: this.Id(co),
        })
      }))),
    )
  }
}

@Component
class ChartWindows extends Vue {
  render(h: CreateElement) {
    return h('div', ([] as VNode[]).concat(...store.frames.map((f) =>
      f.modules.catalogOverPlot.cos.map((co) => {
        return h(CatalogChartWindow, {
          props: {
            module: store.modules.catalogOverPlot,
            co,
            frameStore: f.modules.catalogOverPlot,
            frame: f,
          },
          key: this.Id(co),
        })
      }))),
    )
  }
}
